import axios from "axios";


export const saveAndCreateOpd = (data) => {
    return axios.post("https://arogyanxtdevapi.fundaclear.in/api/v1/Patient",{basicDetail: data});
  };